module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// ../~/axios/index.js
// module id = 1263
// module chunks = 1